import { Building2, Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

export type DdStaffLens = "dealer" | "internal";

type Props = {
  value: DdStaffLens;
  onChange: (next: DdStaffLens) => void;
  className?: string;
};

/**
 * Segmented control for DD account managers / super admins: dealer-facing vs internal workspace.
 * Light-only styling (no dark: / opacity fills).
 */
export function DdStaffLensToggle({ value, onChange, className }: Props) {
  return (
    <div
      className={cn(
        "inline-flex w-full max-w-md sm:w-auto rounded-2xl p-1",
        "bg-slate-100 border border-slate-200 shadow-sm",
        className
      )}
      role="tablist"
      aria-label="Application workspace view"
    >
      <button
        type="button"
        role="tab"
        aria-selected={value === "dealer"}
        onClick={() => onChange("dealer")}
        className={cn(
          "relative flex-1 sm:flex-initial flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium transition-colors",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2",
          value === "dealer"
            ? "text-indigo-950 bg-white shadow-sm border border-slate-200"
            : "text-slate-600 hover:text-slate-900"
        )}
      >
        <Building2 className="h-4 w-4 shrink-0" aria-hidden />
        <span>Dealer view</span>
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={value === "internal"}
        onClick={() => onChange("internal")}
        className={cn(
          "relative flex-1 sm:flex-initial flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium transition-colors",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-500 focus-visible:ring-offset-2",
          value === "internal"
            ? "text-violet-950 bg-violet-100 shadow-sm border border-violet-200"
            : "text-slate-600 hover:text-slate-900"
        )}
      >
        <Sparkles className="h-4 w-4 shrink-0" aria-hidden />
        <span>Internal view</span>
      </button>
    </div>
  );
}
